module.exports = "<div ng-show=\"showHead\" class=\"head-info\"><span class=\"members-info\" ng-click=\"setMembers()\"></span></div><div class=\"message\" ng-class=\"message(fact).isOut? 'outcome' : 'income'\"><div class=\"message-info\"><span class=\"message-sender\" ng-click=\"setSender()\"></span> <span class=\"message-date\">{{message().date}}</span></div><div class=\"message-body\"></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/chat-viewer/chat-viewer-node.component.html
// module id = 1021
// module chunks = 0